export default __webpack_public_path__ + "static/4-58f63d64a77bc7a905c361b263a32882.webp";